module.exports = __webpack_public_path__ + "img/pattern-man.5031169e.png";